import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'


var config = {
    apiKey: "AIzaSyBZB0cKIRyvTyRqFIHCvkC4D70bZdaLzMY",
    authDomain: "net-ninja-mario-dc1f3.firebaseapp.com",
    databaseURL: "https://net-ninja-mario-dc1f3.firebaseio.com",
    projectId: "net-ninja-mario-dc1f3",
    storageBucket: "net-ninja-mario-dc1f3.appspot.com",
    messagingSenderId: "1084449662486"
  };
  firebase.initializeApp(config);
  firebase.firestore().settings({ timestampsInSnapshots: true})

  export default firebase